
export enum ValueStrategyType {

    SelectChildIfOnlyChild = "SelectChildIfOnlyChild",

    SelectAll = "SelectAll"
}
